import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RecurringInvoiceHistoryService } from 'src/app/services/recurring-invoice-history.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-recurring-invoice-history',
  templateUrl: './recurring-invoice-history.component.html',
  styleUrls: ['./recurring-invoice-history.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class RecurringInvoiceHistoryComponent implements OnInit {

  IsHaveTable: boolean = false;
  customerInvoiceList: any[] = [];
  filteredItems: any[] = [];
  transdate: string;
  theirref: string;
  ourref: string;
  dataSource = new MatTableDataSource<any>();
  showTable: boolean = false;
  @ViewChild(MatPaginator, { static: true }) paginatorRef: MatPaginator;

  displayedColumns: string[] = [
    'reportName',
    'status',
    'transDate',
    'totalAmount',
    'Action'

  ];
  form:FormGroup

  constructor(
    private toastr: ToastrService,
    private recurringInvoiceHistoryService: RecurringInvoiceHistoryService,
    private datePipe: DatePipe,
    private paginatorIntl: MatPaginatorIntl,
    private formBuilder:FormBuilder,
  ) {
  }
  rowCollection: any[] = [];
  filteredList: any[] = [];

  ngOnInit(): void {
    this.form=this.formBuilder.group({
      searchquery:[],
    })
    this.getData();
  }

  getData() {
    this.form.reset()
    this.recurringInvoiceHistoryService.getBillingReportDetails().subscribe(result => {
      if (result) {
        this.showTable = true;
        console.log('result : ', result);
        this.rowCollection = result;
        this.rowCollection.forEach((item) => {
          item.totalAmount = this.replaceSpaces(item.totalAmount);
          item.transDate = this.datePipe.transform(item.transDate, 'MMM-yyyy');
        })
        this.dataSource = new MatTableDataSource(this.rowCollection);
        this.dataSource.paginator = this.paginatorRef;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  badgeCol(status) {
    switch (status) {
      case "Success":
        return "#23c00a";
      case "Failure":
        return "#F50100";
      case "Partial failure":
        return "#ff6666";
      case "Partial success":
        return "green";
      default:
        return "#43BC6B";
    }
  }

  replaceSpaces(str: string): string {
    const replaced = str?.replace(/(?<!R)\s/g, ',');
    return replaced;
  }

  formatDate(date: string) {
    return this.datePipe.transform(date, 'MMM-yyyy');
  }

  formatAmount(amount) {
    const amountString = amount.replace(/[^\d.]/g, '');
    const amountNumber = parseFloat(amountString);
    return amountNumber.toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR' });
  }

  download(element: any) {
    var postData = {
      serviceProviderId: element.id
    };
    this.recurringInvoiceHistoryService.getInvoiceBatchReportData(postData).subscribe(res => {
      if (res) {
        const linkSource = 'data:application/pdf;base64, ' + res;
        const downloadLink = document.createElement('a');
        const fileName = `HC Approved Recurring Invoice Report.xls`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
      this.toastr.success(`HC Approved Recurring Invoice Report downloaded successfully`);
    });
  }

}
